import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Link } from '@calendly/ui/components/link';
import { Popup, Body, Footer } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { createContext, useCallback, useContext, forwardRef } from 'react';
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants';
import { useTrack, useTrackOnce } from 'hooks/analytics_events/useTrack';
import { useAcceptTermsMutation } from './api';
const bodyContentCss = "bdewea4";
const bodyContentPhoneCss = "bnhmfcy";
const summaryBoxCss = "s13sppvi";
const summaryListCss = "su07uln";
const SummaryList = forwardRef((props, ref) => <ul ref={ref} {...props} className={classNames(summaryListCss, props.className)} />);
const termsLinkCss = "t1wqczda";
const TermsUrlContext = createContext(null);
const TermsLinkClickContext = createContext(null);
const TermsLink = ({
  children
}) => {
  const href = useContext(TermsUrlContext);
  const onClick = useContext(TermsLinkClickContext);
  return <Link className={termsLinkCss} href={href} target="_blank" rel="noopener noreferrer" underline={false} onClick={onClick || undefined}>
      {children}
    </Link>;
};
export const TermsOfServicePopup = ({
  orgTermsStatus
}) => {
  const isPhone = useDeviceType('isPhone');
  const [acceptTerms, {
    isLoading: isAccepting
  }] = useAcceptTermsMutation();
  const track = useTrack();
  const handleTermsLinkClick = useCallback(() => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        action: 'interaction',
        cta_key: 'tos_update_popup',
        cta_text: 'terms_of_use_popup'
      }
    });
  }, [track]);
  useTrackOnce(true, {
    name: TRACKING_EVENT_NAMES.CTA_SHOWN,
    properties: {
      cta_key: 'tos_update_popup',
      cta_text: 'tos_popup_2026'
    }
  });
  const newTermsUrl = orgTermsStatus?.termsLinkUrl ?? '';
  const handleReviewTerms = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        action: 'interaction',
        cta_key: 'tos_update_popup',
        cta_text: 'review_terms_tos_popup'
      }
    });
    window.open(newTermsUrl, '_blank', 'noopener,noreferrer');
  };
  const handleAcceptTerms = () => {
    if (isAccepting || orgTermsStatus?.acceptedAt) return;
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        action: 'interaction',
        cta_key: 'tos_update_popup',
        cta_text: 'accept_terms_tos_popup'
      }
    });
    acceptTerms().catch(() => {});
  };
  return <TermsLinkClickContext.Provider value={handleTermsLinkClick}>
      <TermsUrlContext.Provider value={newTermsUrl}>
        <Popup isBlocking onClose={() => {}} size="medium" title={I18n.t('publisher.terms_of_service.popup.title')}>
          <Body>
            <div className={classNames(bodyContentCss, {
            [bodyContentPhoneCss]: isPhone
          })}>
              <BodyText>
                {HtmlParser(I18n.t('publisher.terms_of_service.popup.message'), {
                TermsLink
              })}
              </BodyText>
              <div className={summaryBoxCss}>
                <BodyText weight="semibold">
                  {I18n.t('publisher.terms_of_service.popup.summary_title')}
                </BodyText>
                <BodyText>{HtmlParser(I18n.t('publisher.terms_of_service.popup.summary_body'), {
                  ul: SummaryList
                })}</BodyText>
              </div>
            </div>
          </Body>
          <Footer>
            <Button decoration="secondary-outline" onClick={handleReviewTerms}>
              {I18n.t('publisher.terms_of_service.popup.review_terms')}
            </Button>
            <Button onClick={handleAcceptTerms} disabled={isAccepting} loading={isAccepting}>
              {I18n.t('publisher.terms_of_service.popup.accept_terms')}
            </Button>
          </Footer>
        </Popup>
      </TermsUrlContext.Provider>
    </TermsLinkClickContext.Provider>;
};

require("./popup.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./popup.js");